import React from "react";
import { Loader2, Mail, Paperclip, Link2, AlertTriangle } from "lucide-react";
import { TEMPLATES } from "@/constants/testIds";

const Chip = ({ icon: Icon, tone, testId, children }) => (
  <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border text-[10px] font-medium ${tone}`}
    data-testid={testId}>
    <Icon className="w-3 h-3" strokeWidth={1.75} /> {children}
  </span>
);

export function RecipientPreviewSummary({ data, loading }) {
  return (
    <div className="mb-3 p-2.5 rounded-md border border-orange-200 bg-orange-50/50 space-y-1.5"
      data-testid={TEMPLATES.recipientSummary}>
      <div className="flex items-center gap-1.5 text-[11px] text-slate-700">
        <Mail className="w-3.5 h-3.5 text-orange-600" strokeWidth={1.75} />
        Así llega la firma a un destinatario externo (HTML final del servidor).
        {loading && (
          <Loader2 className="w-3.5 h-3.5 ml-auto animate-spin text-orange-600" strokeWidth={1.75}
            data-testid={TEMPLATES.recipientLoading} />
        )}
      </div>
      {data && (
        <div className="flex flex-wrap gap-1.5">
          <Chip icon={Paperclip} tone="border-emerald-200 bg-emerald-50 text-emerald-700"
            testId={TEMPLATES.recipientEmbeddedCount}>
            {data.embedded.length} embebidas (CID)
          </Chip>
          <Chip icon={Link2} tone="border-slate-200 bg-white text-slate-600"
            testId={TEMPLATES.recipientExternalCount}>
            {data.external.length} externas (URL)
          </Chip>
          {data.failures.length > 0 && (
            <Chip icon={AlertTriangle} tone="border-amber-200 bg-amber-50 text-amber-800"
              testId="recipient-failures-count">
              {data.failures.length} no embebibles
            </Chip>
          )}
        </div>
      )}
    </div>
  );
}
